import * as React from 'react';
import { CSSTransition } from 'react-transition-group';
import { BannerNotification, Text } from '@siteground/styleguide';
import './notification.css';

const Notification = (props) => {
  const {
    message,
    title,
    type,
    enter,
    onEnter,
    onEntered,
    onEntering,
    exit,
    onExit,
    onExited,
    onExiting,
    'data-e2e': dataE2E,
    tabIndex
  } = props;

  return (
    <CSSTransition
      classNames="chat-notification chat-notification--animation"
      in={props['in']}
      enter={enter}
      onEnter={onEnter}
      onEntered={onEntered}
      onEntering={onEntering}
      exit={exit}
      onExit={onExit}
      onExited={onExited}
      onExiting={onExiting}
      mountOnEnter
      unmountOnExit
      timeout={{
        enter: 1,
        exit: 500
      }}
    >
      <BannerNotification density="small" type={type} title={title} data-e2e={dataE2E} tabIndex={tabIndex}>
        <Text weight="bold">{message}</Text>
      </BannerNotification>
    </CSSTransition>
  );
};

Notification.defaultProps = {
  'data-e2e': 'notification',
  tabIndex: -1
};

export default Notification;
